import { Children, PropsWithChildren } from "react";
import BackButton from "pages/application/templates/shared/BackButton";
import "./question-actions.scss";

export const QuestionNavigation = ({ children }: PropsWithChildren) => (
  <div className="question-navigation">
    <BackButton />
    {Children.toArray(children).length > 0 && (
      <div className="question-navigation__item question-navigation__item--continue">{children}</div>
    )}
  </div>
);

export default QuestionNavigation;
